import { FontFaces } from '@fluentui/styles';

export const fontFaces: FontFaces = [
  {
    name: 'Segoe UI',
    paths: [
      'https://res-1.cdn.office.net/files/fabric-cdn-prod_20221209.001/assets/fonts/segoeui-westeuropean/segoeui-regular.woff2',
    ],
    props: { fontWeight: 400 },
  },
  {
    name: 'Segoe UI',
    paths: [
      'https://res-1.cdn.office.net/files/fabric-cdn-prod_20221209.001/assets/fonts/segoeui-westeuropean/segoeui-semibold.woff2',
    ],
    props: { fontWeight: 600 },
  },
  {
    name: 'Segoe UI',
    paths: [
      'https://res-1.cdn.office.net/files/fabric-cdn-prod_20221209.001/assets/fonts/segoeui-westeuropean/segoeui-bold.woff2',
    ],
    props: { fontWeight: 700 },
  },
];
